import Select from "components/DesignSystem/Select/Select";
import { useFormikContext } from "formik";

type SuffixSelectProps = {
  options: string[];
  defaultValue?: string;
};

export const SuffixSelect = ({ options, defaultValue }: SuffixSelectProps) => {
  const { values, setFieldValue } = useFormikContext<{
    entitySuffix: string;
  }>();

  const handleChange = (value: string) => setFieldValue("entitySuffix", value);

  return (
    <span className="t-flex t-items-center t-self-stretch t-border-0 t-border-l t-border-solid t-border-neutral-10 t-pl-1">
      <Select.Root
        appearance="borderless"
        size="small"
        value={values.entitySuffix || defaultValue}
        onValueChange={handleChange}
      >
        <Select.Trigger>
          <Select.Value />
        </Select.Trigger>
        <Select.Content>
          {options.map((option) => (
            <Select.Item key={option} value={option}>
              {option}
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Root>
    </span>
  );
};
